module.exports = __webpack_public_path__ + "static/logo_round-659906443a9d71f1b3a8992a58d62ec8.png";